/**
 * Fullscreen control for the PDF preview block (blocks/pdf_preview_block.html).
 *
 * The button is rendered hidden and only revealed here, so browsers without the
 * Fullscreen API never show a control that would do nothing. Below tablet the
 * frame itself is hidden by CSS, so there is nothing to expand.
 */
const LABEL_ENTER = 'Ecran complet'
const LABEL_EXIT = 'Ieși din ecran complet'
const ICON_ENTER = 'ph:corners-out'
const ICON_EXIT = 'ph:corners-in'

export class PdfPreview {
  constructor() {
    this.blocks = document.querySelectorAll('.pdf-preview')
    if (!this.blocks.length) return
    if (!document.fullscreenEnabled) return

    this.blocks.forEach((block) => this.setup(block))

    document.addEventListener('fullscreenchange', () => {
      this.blocks.forEach((block) => this.sync(block))
    })
  }

  setup(block) {
    const button = block.querySelector('[data-pdf-fullscreen]')
    const frame = block.querySelector('.pdf-preview-frame')
    if (!button || !frame) return

    button.hidden = false
    button.addEventListener('click', () => {
      if (document.fullscreenElement === frame) {
        document.exitFullscreen()
      } else {
        // Failure is non-fatal: the file is still reachable through the
        // open/download links next to this button.
        frame.requestFullscreen().catch(() => {})
      }
    })
  }

  sync(block) {
    const button = block.querySelector('[data-pdf-fullscreen]')
    const frame = block.querySelector('.pdf-preview-frame')
    if (!button || !frame) return

    const active = document.fullscreenElement === frame
    const label = active ? LABEL_EXIT : LABEL_ENTER

    button.setAttribute('aria-pressed', String(active))
    button.querySelector('.pdf-fullscreen-label').textContent = label
    button.querySelector('iconify-icon').setAttribute('icon', active ? ICON_EXIT : ICON_ENTER)

    // The frame is aria-hidden while it is a decorative preview; expanded to
    // fill the screen it becomes the actual content, so expose it.
    frame.setAttribute('aria-hidden', String(!active))
    frame.querySelector('iframe').setAttribute('tabindex', active ? '0' : '-1')
  }
}
